<template>
  <div class="sidebar eb-sidebar sidebar-height" v-on-clickaway="hideMobile">
    <slot>Sidebar</slot>
  </div>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';
import { hideMobile } from '@/mixins/hideMobile';

export default {
  name: 'sidebar',
  mixins: [ clickaway, hideMobile ],
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.isFixed();
  },
  methods: {
    isFixed() {
      this.fixed ? document.body.classList.add('sidebar-fixed') : document.body.classList.remove('sidebar-fixed');
      return this.fixed;
    },
  },
};
</script>
<style scoped>

.eb-sidebar {
    z-index: 10;
    background: linear-gradient(
        180deg,
        var(--theme-gradient-start) 0%,
        var(--theme-gradient-end) 100%
    );
    bottom: 0;
    -webkit-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
    box-shadow: 18px 0 42px -30px rgba(15, 23, 42, 0.55);
}

.sidebar-height {
  height: calc(100vh - 64px);
}
</style>
<style>
.sidebar .nav-link {
    color: rgba(255, 255, 255, 0.78) !important;
    border-radius: var(--radius-sm);
    border: 0 !important;
    box-shadow: none !important;
    outline: none !important;
    background-clip: padding-box;
    transform: none !important;
    transition:
        background-color 0.18s ease,
        border-color 0.18s ease,
        color 0.18s ease;
}

.sidebar .nav-item,
.sidebar .nav-link,
.sidebar .nav-dropdown-toggle {
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
}

.sidebar .nav-link:hover,
.sidebar .nav-link:focus,
.sidebar .nav-link:focus-visible {
    color: rgba(255, 255, 255, 0.96) !important;
    background: var(--nav-hover-bg) !important;
    border-color: transparent !important;
    transform: none !important;
    outline: none !important;
    box-shadow: none !important;
}

.sidebar .nav-link.router-link-active,
.sidebar .nav-link.router-link-exact-active,
.sidebar .nav-link.active {
    color: rgba(255, 255, 255, 1) !important;
    background: var(--nav-active-bg) !important;
    border-color: transparent !important;
    box-shadow: none;
    transform: none !important;
}

.sidebar .nav-link .nav-icon {
    color: rgba(255, 255, 255, 0.74) !important;
    font-size: 16px;
    transform: none !important;
    transition: color 0.2s ease;
}

.sidebar .nav-link.router-link-active .nav-icon,
.sidebar .nav-link.router-link-exact-active .nav-icon,
.sidebar .nav-link.active .nav-icon {
    color: rgba(255, 255, 255, 1) !important;
}

.sidebar .nav-link .nav-link-label,
.sidebar .nav-link .dropdown-nav-label {
    font-weight: 600;
    font-size: 14px;
    transform: none !important;
}

/* Sidebar nav item spacing */
.sidebar .nav-item {
    margin-bottom: 0.35rem;
    overflow: hidden;
}

@media (min-width: 992px) {
    .sidebar-minimized .sidebar .nav-item:hover,
    .sidebar-minimized .sidebar .nav-item:focus-within,
    .sidebar-minimized .sidebar .nav > .nav-dropdown:hover,
    .sidebar-minimized .sidebar .nav > .nav-dropdown.open {
        background: transparent !important;
        box-shadow: none !important;
    }

    .sidebar-minimized .sidebar .nav-item:hover > .nav-link,
    .sidebar-minimized .sidebar .nav-item:focus-within > .nav-link,
    .sidebar-minimized .sidebar .nav-dropdown.open > .nav-dropdown-toggle {
        background: rgba(30, 58, 138, 0.96) !important;
        color: rgba(255, 255, 255, 0.98) !important;
        box-shadow: 0 8px 20px -14px rgba(15, 23, 42, 0.9);
    }

    .sidebar-minimized .sidebar .nav-item:hover > .nav-link .nav-link-label,
    .sidebar-minimized .sidebar .nav-item:focus-within > .nav-link .nav-link-label,
    .sidebar-minimized .sidebar .nav-dropdown.open > .nav-dropdown-toggle .dropdown-nav-label {
        color: rgba(255, 255, 255, 0.98) !important;
    }
}
</style>
